import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { connect } from 'react-redux';

import NotificationModal from '../notificationModal/notificationModal.js';
import { mergeArrays } from '../../../util/index.js';
import { createServiceAction } from '../../../util/actionHelper.js';

class NotificationArea extends Component {
    constructor(props) {
        super(props);
        this.state = {
            notifyModal: false,
            message: '',
            notificationId: null
        };
    }
    notifyModalOpen = (modalopen, message, notificationId) => {
        this.setState({ notifyModal: modalopen, message, notificationId });
    };
    closeNotifyModal = (notificationId) => {
        const { updateNotificationStatus,litmosNotificationStatus } = this.props;

        if (notificationId && notificationId !== "litmosId") {
            const id = []
            id.push(notificationId)
            updateNotificationStatus({ notificationIds: id })
        }
        this.setState({ notifyModal: false });
        litmosNotificationStatus(true)
    };

    render() {
        const { notifications, isRslUser, userGroup } = this.props;
        const { notifyModal, message, notificationId } = this.state;
        let uniqueGroups = []
        if (isRslUser) {
            const allGroups = notifications && notifications.map(e => e.userGroups)
            uniqueGroups = mergeArrays(allGroups)
        }

        return (
            <span>
                {notifications ?
                    <span>
                        <div className='notification-head'>NOTIFICATIONS</div>
                        {(notifications.length > 0) ?
                            notifications.map((notification) =>
                                (
                                    <span key={notification.id}>
                                        {
                                            isRslUser ?
                                                <span>
                                                    {notification.userGroups.includes('Rsl') &&
                                                        new Date(moment(notification.startDate).utc().format('DD-MMM-YYYY')) <= new Date()
                                                        && new Date(moment(notification.endDate).utc().format('DD-MMM-YYYY')) >= new Date() ?


                                                        <li className={` custom-notification-section ${!notification.isRead ? 'unread-line' : ''}`}>

                                                            <div className="ncss-col-sm-9 notification-message">
                                                                <i class="fas fa-bullhorn"> </i>
                                                                <span className='text-notify'>
                                                                    {notification.message.length > 99 ? notification.message.substr(0, 100) + '....' : notification.message}
                                                                </span>
                                                            </div>
                                                            <div className="ncss-col-sm-2 link-text"
                                                                onClick={() => this.notifyModalOpen(true, notification.message, notification.id)}>Click Here for More Details</div>
                                                            {/* <div className="ncss-col-sm-1">
                          <span className='link-text-close'>CLOSE <i class="fas fa-times"></i></span>
                        </div> */}
                                                        </li >
                                                        :
                                                        <span>
                                                            {isRslUser && !uniqueGroups.includes(userGroup) ?
                                                                <div className="notification-message align-center">

                                                                    <span className='text-notify-no'>
                                                                        No notifications found
                                                         </span>
                                                                </div>
                                                                :
                                                                null
                                                            }
                                                        </span>

                                                    }

                                                </span>
                                                :
                                                <li className={` custom-notification-section ${!notification.isRead ? 'unread-line' : ''}`}>
                                                    <div className="ncss-col-sm-9 notification-message">
                                                        <i class="fas fa-bullhorn"> </i>
                                                        <span className='text-notify'>
                                                            {notification.message.length > 99 ? notification.message.substr(0, 100) + '....' : notification.message}
                                                        </span>
                                                    </div>
                                                    <div className="ncss-col-sm-2 link-text"
                                                        onClick={() => this.notifyModalOpen(true, notification.message, notification.id)}>Click Here for More Details</div>
                                                    {/* <div className="ncss-col-sm-1">
                          <span className='link-text-close'>CLOSE <i class="fas fa-times"></i></span>
                        </div> */}
                                                </li >

                                        }
                                    </span>
                                )
                            ) :
                            <div className="notification-message align-center">

                                <span className='text-notify-no'>
                                    No notifications found
                        </span>
                            </div>
                        }
                        <span>
                            {isRslUser && !uniqueGroups.includes(userGroup) ?
                                <div className="notification-message align-center">

                                    <span className='text-notify-no'>

                                    </span>
                                </div>
                                :
                                null
                            }

                        </span>
                        <NotificationModal message={message} notificationId={notificationId} notifyModal={notifyModal} closeModal={this.closeNotifyModal} />
                    </span>
                    :
                    null
                }
            </span>
        )
    }
}
NotificationArea.propTypes = {
    notifications: PropTypes.array
};

export const mapDispatchToProps = dispatch => ({

    updateNotificationStatus: (ids) => {
        dispatch(createServiceAction('readNotification', 'submitted')(ids));
    }
});

export default connect(
    null,
    mapDispatchToProps
)(NotificationArea);

